module.exports = __webpack_public_path__ + "static/img/039信用中国.a0c142b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/039信用中国.jpg
// module id = Uj1l
// module chunks = 0